module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [(_vm.isRoot) ? _c('v-client-list') : _vm._e(), _vm._v(" "), (_vm.itemId !== null && _vm.itemId !== 'root') ? _c('v-client-page', {
    attrs: {
      "mode": 'page',
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "itemId": _vm.itemId,
      "profileId": _vm.profileId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.humanId !== null) ? _c('v-human-page', {
    attrs: {
      "mode": 'page',
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "itemId": _vm.humanId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.fagencyId !== null) ? _c('v-foreign-agency-page', {
    attrs: {
      "mode": 'page',
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "itemId": _vm.fagencyId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.foreignId !== null) ? _c('v-foreign-page', {
    attrs: {
      "mode": 'page',
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "itemId": _vm.foreignId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.lonerId !== null) ? _c('v-loner-page', {
    attrs: {
      "mode": 'page',
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "itemId": _vm.lonerId
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c35bdbe6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/ClientPanel.vue
// module id = 1118
// module chunks = 1